const params = new URLSearchParams(window.location.search);
const sessie = params.get('sessie') || 'onbekend';
const app = document.getElementById('passessie-app');
const backendUrl = app.dataset.backendUrl;
const producten = JSON.parse(document.getElementById('ps-producten-data').textContent);

let huidigeNaam = '';
let vorigeRegels = [];

function formatEuro(cents) {
  return '€' + (cents / 100).toFixed(2).replace('.', ',');
}

function prijsVanProduct(productId) {
  const p = producten.find(pp => pp.id === productId);
  return p ? p.price : 0;
}

function vulMaatOpties(rij) {
  const artikelSelect = rij.querySelector('.ps-artikel');
  const maatSelect = rij.querySelector('.ps-maat');
  const product = producten.find(p => p.id === artikelSelect.value);
  maatSelect.innerHTML = '';
  if (!product) return;
  product.variants.forEach(v => {
    const opt = document.createElement('option');
    opt.value = v.id;
    opt.textContent = v.title;
    maatSelect.appendChild(opt);
  });
}

function wireRow(row) {
  row.querySelector('.ps-artikel').addEventListener('change', () => {
    vulMaatOpties(row);
    ververs();
  });
  row.querySelector('.ps-maat').addEventListener('change', ververs);
  vulMaatOpties(row);

  row.querySelector('.ps-verwijder').addEventListener('click', () => {
    if (document.querySelectorAll('.ps-item-row').length > 1) {
      row.remove();
      ververs();
    }
  });
}

function nieuweRij() {
  const div = document.createElement('div');
  div.className = 'ps-item-row';
  div.innerHTML = `
    <select class="ps-artikel">
      ${producten.map(p => `<option value="${p.id}">${p.title} — ${formatEuro(p.price)}</option>`).join('')}
    </select>
    <select class="ps-maat"></select>
    <button type="button" class="ps-verwijder">x</button>
  `;
  return div;
}

document.querySelectorAll('.ps-item-row').forEach(row => {
  wireRow(row);
});

document.getElementById('ps-artikel-toevoegen').addEventListener('click', () => {
  const rij = nieuweRij();
  document.getElementById('ps-items').appendChild(rij);
  wireRow(rij);
  ververs();
});

function vulRijenIn(regels) {
  const items = document.getElementById('ps-items');
  items.innerHTML = '';
  const lijst = regels.length ? regels : [{}];
  lijst.forEach(regel => {
    const rij = nieuweRij();
    items.appendChild(rij);
    if (regel.productId) rij.querySelector('.ps-artikel').value = regel.productId;
    wireRow(rij);
    if (regel.variantId) rij.querySelector('.ps-maat').value = regel.variantId;
  });
  ververs();
}

function huidigTotaal() {
  return [...document.querySelectorAll('.ps-item-row')].reduce((som, row) => {
    return som + prijsVanProduct(row.querySelector('.ps-artikel').value);
  }, 0);
}

function vorigTotaal() {
  return vorigeRegels.reduce((som, r) => som + prijsVanProduct(r.productId), 0);
}

function ververs() {
  const totaal = huidigTotaal();
  const vorig = vorigTotaal();
  const verschil = totaal - vorig;
  const el = document.getElementById('ps-overzicht');

  let html = `<div class="ps-totaal-regel"><span>Totaal</span><span>${formatEuro(totaal)}</span></div>`;

  if (verschil > 0) {
    html += `<p class="ps-betaal-info">${vorig > 0 ? 'Bij te betalen (verschil met eerder betaald bedrag): ' + formatEuro(verschil) : 'Te betalen: ' + formatEuro(totaal)}</p>`;
    html += `
      <div class="ps-betaal-opties">
        <label><input type="radio" name="ps-betaalmethode" value="Pin"> Pinnen</label>
        <label><input type="radio" name="ps-betaalmethode" value="Contant"> Contant</label>
      </div>`;
    } else if (verschil < 0) {
    html += `<div class="ps-restitutie">Er was al ${formatEuro(vorig)} betaald, nu gekozen: ${formatEuro(totaal)} — meld dit bij een collega/medewerker voor een terugbetaling van ${formatEuro(Math.abs(verschil))}.</div>`;
  } else if (vorig > 0) {
    html += `<p class="ps-betaal-info">Al volledig betaald, geen nieuwe betaling nodig.</p>`;
  }

  el.innerHTML = html;
}

function toonKeuzeStap() {
  document.getElementById('ps-step-naam').hidden = true;
  document.getElementById('ps-step-keuze').hidden = false;
  ververs();
}

document.getElementById('ps-volgende').addEventListener('click', async () => {
  const voornaam = document.getElementById('ps-voornaam').value.trim();
  const achternaam = document.getElementById('ps-achternaam').value.trim();
  if (!voornaam || !achternaam) {
    document.getElementById('ps-naam-error').hidden = false;
    return;
  }
  document.getElementById('ps-naam-error').hidden = true;
  huidigeNaam = voornaam + ' ' + achternaam;

  const checkResponse = await fetch(
    backendUrl + '/check?sessie=' + encodeURIComponent(sessie) +
    '&naam=' + encodeURIComponent(huidigeNaam)
  );

  if (checkResponse.status === 403) {
    const foutdata = await checkResponse.json();
    document.getElementById('ps-step-naam').innerHTML =
      '<p>' + foutdata.message + '</p>';
    return;
  }

  const check = await checkResponse.json();

  if (check.gevonden) {
    vorigeRegels = check.regels;
    const el = document.getElementById('ps-welkom-terug');
    const lijst = check.regels.map(r => `<li>${r.titel}, maat ${r.maat}</li>`).join('');
    el.hidden = false;
    el.innerHTML =
      '<p>Welkom terug. U vulde eerder in:</p>' +
      '<ul class="ps-vorige-lijst">' + lijst + '</ul>' +
      '<button type="button" id="ps-aanpassen">Aanpassen</button>' +
      '<button type="button" id="ps-klopt">Klopt, verder</button>';

    document.getElementById('ps-aanpassen').onclick = () => {
      vulRijenIn(vorigeRegels);
      toonKeuzeStap();
    };
    document.getElementById('ps-klopt').onclick = () => {
      document.getElementById('ps-step-naam').hidden = true;
      document.getElementById('ps-step-klaar').hidden = false;
    };
    return;
  }

  vorigeRegels = [];
  toonKeuzeStap();
});

document.getElementById('ps-versturen').addEventListener('click', async () => {
  const akkoord = document.getElementById('ps-akkoord').checked;
  if (!akkoord) {
    document.getElementById('ps-akkoord-error').hidden = false;
    return;
  }
  document.getElementById('ps-akkoord-error').hidden = true;

  const totaal = huidigTotaal();
  const vorig = vorigTotaal();
  const verschil = totaal - vorig;
  let betaalmethode = null;

  if (verschil > 0) {
    const gekozen = document.querySelector('input[name="ps-betaalmethode"]:checked');
    if (!gekozen) {
      document.getElementById('ps-betaal-error').hidden = false;
      return;
    }
    betaalmethode = gekozen.value;
  }
  document.getElementById('ps-betaal-error').hidden = true;

    const regels = [...document.querySelectorAll('.ps-item-row')].map(row => {
    const productId = row.querySelector('.ps-artikel').value;
    const variantId = row.querySelector('.ps-maat').value;
    const product = producten.find(p => p.id === productId);
    const variant = product ? product.variants.find(v => v.id === variantId) : null;
    return {
      variantId,
      productId,
      titel: product ? product.title : '',
      maat: variant ? variant.title : '',
    };
  });

  const knop = document.getElementById('ps-versturen');
  const oorspronkelijkeTekst = knop.textContent;
  knop.disabled = true;
  knop.textContent = 'Bezig met versturen...';

  let submitResponse;
  try {
    submitResponse = await fetch(backendUrl + '/submit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
      sessie,
      naam: huidigeNaam,
      regels,
      totaal,
      vorig,
      verschil,
      betaalmethode,
    }),
    });
    } catch (e) {
    console.error('Submit-fout:', e);
    knop.disabled = false;
    knop.textContent = oorspronkelijkeTekst;
    document.getElementById('ps-betaal-error').hidden = false;
    document.getElementById('ps-betaal-error').textContent =
      'Versturen is niet gelukt. Controleer uw internetverbinding en probeer het opnieuw.';
    return;
  }

  if (submitResponse.status === 403) {
    const foutdata = await submitResponse.json();
    document.getElementById('ps-step-keuze').innerHTML = '<p>' + foutdata.message + '</p>';
    return;
  }

  if (!submitResponse.ok) {
    knop.disabled = false;
    knop.textContent = oorspronkelijkeTekst;
    document.getElementById('ps-betaal-error').hidden = false;
    document.getElementById('ps-betaal-error').textContent =
      'Er ging iets mis bij het versturen. Probeer het nog eens, of meld dit bij een medewerker.';
    return;
  }

  const itemsLijst = regels.map(r => {
    const product = producten.find(p => p.id === r.productId);
    const variant = product ? product.variants.find(v => v.id === r.variantId) : null;
    return `<li>${product ? product.title : '?'}, maat ${variant ? variant.title : '?'} — ${formatEuro(product ? product.price : 0)}</li>`;
  }).join('');

  let betaalRegel = '';
  if (verschil > 0) {
    betaalRegel = vorig > 0
      ? `<p class="ps-betaal-info">Eerder betaald: ${formatEuro(vorig)}</p>
         <p class="ps-betaal-info">Te betalen: ${formatEuro(verschil)} via ${betaalmethode}</p>`
      : `<p class="ps-betaal-info">Te betalen: ${formatEuro(verschil)} via ${betaalmethode}</p>`;
  } else if (verschil < 0) {
    betaalRegel = `<div class="ps-restitutie">Er was al ${formatEuro(vorig)} betaald, nu gekozen: ${formatEuro(totaal)} — meld dit bij een collega/medewerker voor een terugbetaling van ${formatEuro(Math.abs(verschil))}.</div>`;
  } else if (vorig > 0) {
    betaalRegel = `<p class="ps-betaal-info">Al volledig betaald, geen nieuwe betaling.</p>`;
  }

  document.getElementById('ps-bonnetje-naam').textContent = huidigeNaam;
  document.getElementById('ps-bonnetje').innerHTML = `
    <ul class="ps-vorige-lijst">${itemsLijst}</ul>
    <div class="ps-totaal-regel"><span>Totaal</span><span>${formatEuro(totaal)}</span></div>
    ${betaalRegel}
  `;

  document.getElementById('ps-step-keuze').hidden = true;
  document.getElementById('ps-step-klaar').hidden = false;
});